<template>
    <div class="documents">
        <div class="card mb-0">
            <div class="card-header">
                <h3>Listado de plantillas</h3>
                <div class="right-wrapper pull-right">
                    <a :href="`/${resource}/create`"
                        class="btn btn-custom btn-sm  mt-2 mr-2"
                    >
                        <i class="fa fa-plus-circle"></i> Nuevo
                    </a>
                </div>
            </div>
            <div class="card-body">
                <div class="row table-responsive"
                    v-loading="loading"
                >
                    <table class="table">
                        <thead>
                            <tr>
                                <th width="70px"
                                    class="text-center"
                                >
                                    #
                                </th>
                                <th>Nombre</th>
                                <th width="300px" class="text-center">Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="items.length">
                                <tr v-for="(item, index) in items"
                                    :class="{ 'text-danger' : !item.active }"
                                >
                                    <td class="text-center">
                                        {{ customIndex(index) }}
                                    </td>
                                    <td>{{ item.name }}</td>
                                    <td>
                                        <div class="flex justify-center"
                                            style="gap: 2px;"
                                        >
                                            <el-button type="primary"
                                                @click="edit(item.id)"
                                            >
                                                Editar
                                            </el-button>
                                            <el-button type="danger"
                                                @click="remove(item)"
                                            >
                                                Eliminar
                                            </el-button>
                                            <el-button type="warning"
                                                @click="changeStatus(item)"
                                            >
                                                {{ item.active ? 'Inhabilitar' : 'Habilitar' }}
                                            </el-button>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                            <template v-else>
                                <tr>
                                    <td colspan="3" class="text-center">No existen registros</td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                    <el-pagination
                        :total="pagination.total"
                        :current-page.sync="pagination.current_page"
                        :page-size="pagination.per_page"
                        @current-change="getRecords"
                        layout="total, prev, pager, next"
                    ></el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'BarcodeConfigurationIndex',

        data() {
            return {
                resource: 'barcode-configuration',
                loading: false,
                items: [],
                pagination: {}
            }
        },

        async created() {
            await this.getRecords()
        },

        methods: {
            async getRecords() {
                try {
                    this.loading = true
                    const { data } = await this.$http.get(`/${this.resource}/records`, {
                        params: this.pagination.current_page
                    })
                    const { data: dataItems, meta } = data
                    this.items = dataItems
                    this.pagination = meta
                } catch (error) {
                    let message = error.response.data.message || 'Ocurrio un error inesperado'
                    this.$message.error(message)
                } finally {
                    this.loading = false
                }
            },

            customIndex(index) {
                return this.pagination.per_page
                    * (this.pagination.current_page - 1) +
                    index + 1
            },

            changeStatus(item) {
                const msg = item.active ? 'Inhabilitar' : 'Habilitar'
                this.$confirm(`¿Seguro de ${msg} el registro?`, 'Advertencia', {
                    confirmButtonText: 'Aceptar',
                    cancelButtonText: 'Cancelar',
                    type: 'warning'
                }).then(async () => {
                    try {
                        const { data } = await this.$http.post(`/${this.resource}/change-status`, {
                            id: item.id,
                            active: !item.active
                        })
                        this.$message.success(data.message)
                        await this.getRecords()
                    } catch (error) {
                        let message = error.response.data.message || 'Ocurrio un error inesperado'
                        this.$message.error(message)
                    }
                }).catch(() => {})
            },

            remove(item) {
                this.$confirm('¿Seguro de eliminar el registro?', 'Advertencia', {
                    confirmButtonText: 'Aceptar',
                    cancelButtonText: 'Cancelar',
                    type: 'warning'
                }).then(async () => {
                    try {
                        const { data } = await this.$http.delete(`/${this.resource}/${item.id}`)
                        this.$message.success(data.message)
                        await this.getRecords()
                    } catch (error) {
                        let message = error.response.data.message || 'Ocurrio un error inesperado'
                        this.$message.error(message)
                    }
                }).catch(() => {})
            },

            edit(id) {
                window.location.href = `/${this.resource}/edit/${id}`
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/js/views/tenant/barcode_configuration/index.vue